import { yup } from '@framework/validation/initYup.ts';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { evaluateExpression } from '../../../../expressions/evaluate/evaluateExpression.ts';
import { type ICreateWidgetFormSchemaInput } from '../../../IWidgetType.ts';
import { setComputeTransform } from '../../computed/setComputedTransform.ts';
import { type ISwitchWidget } from './ISwitchWidget.ts';

/**
 * Ritorna lo schema di validazione per il tipo di dato condizionale.
 */
function getConditionalSchema(widget: ISwitchWidget) {
  switch (widget.datatype) {
    case Datatype.Boolean:
      return yup.boolean();
    case Datatype.Number:
      return yup.number();
    case Datatype.Date:
      // Le gestiamo allo stesso modo dei widget data.
      // Gli switch widget per il momento supportano solo il formato YYYY-MM-DD (senza orario).
      return yup.string().stringDate('YYYY-MM-DD');
    case Datatype.String:
      return yup.string();
    default:
      console.warn(`Unsupported datatype ${widget.datatype as any}`);
      return yup.mixed();
  }
}

export function createSwitchWidgetSchema({
  widget,
  parentScope,
}: ICreateWidgetFormSchemaInput<ISwitchWidget>) {
  return setComputeTransform(
    widget.expression,
    parentScope,
    getConditionalSchema(widget).notRequired(),
    (expression, variables) => {
      return evaluateExpression(expression, { variables });
    },
  );
}
